/* ==========================================================================
   Mobile Banner Improvements JavaScript
   Touch swipe and enhanced controls for mobile banners
   Version: 1.0
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function() {
  // Only run on mobile
  if (window.innerWidth > 768) return;
  
  const carousel = document.getElementById('heroCarousel');
  if (!carousel) return;
  
  const track = carousel.querySelector('.carousel-track');
  const slides = carousel.querySelectorAll('.carousel-slide');
  const dots = carousel.querySelectorAll('.carousel-dot');
  
  if (!track || slides.length === 0) return;
  
  let currentSlide = 0;
  let startX = 0;
  let currentX = 0;
  let isDragging = false;
  let autoPlayInterval;
  
  // Add progress bar
  const progressContainer = document.createElement('div');
  progressContainer.className = 'carousel-progress';
  progressContainer.innerHTML = '<div class="carousel-progress-bar"></div>';
  carousel.appendChild(progressContainer);
  const progressBar = progressContainer.querySelector('.carousel-progress-bar');
  
  // Add slide counter
  const slideCounter = document.createElement('div');
  slideCounter.className = 'slide-counter';
  updateSlideCounter();
  carousel.appendChild(slideCounter);
  
  // Update slide position
  function updateSlide(index, animate = true) {
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;
    
    currentSlide = index;
    
    if (animate) {
      track.style.transition = 'transform 0.5s ease';
    } else {
      track.style.transition = 'none';
    }
    
    track.style.transform = `translateX(-${currentSlide * 100}%)`;
    
    // Update dots
    dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === currentSlide);
    });
    
    // Update counter
    updateSlideCounter();
    
    // Reset progress bar
    resetAutoPlay();
  }
  
  // Update slide counter
  function updateSlideCounter() {
    if (slideCounter) {
      slideCounter.textContent = `${currentSlide + 1} / ${slides.length}`;
    }
  }
  
  // Touch events
  track.addEventListener('touchstart', handleTouchStart, { passive: true });
  track.addEventListener('touchmove', handleTouchMove, { passive: true });
  track.addEventListener('touchend', handleTouchEnd);
  
  function handleTouchStart(e) {
    startX = e.touches[0].clientX;
    currentX = startX;
    isDragging = true;
    
    // Pause autoplay
    clearInterval(autoPlayInterval);
    progressBar.style.transition = 'none';
    progressBar.style.width = '0';
  }
  
  function handleTouchMove(e) {
    if (!isDragging) return;
    
    currentX = e.touches[0].clientX;
    const diff = currentX - startX;
    const percent = (diff / carousel.offsetWidth) * 100;
    
    // Move track with finger
    track.style.transition = 'none';
    track.style.transform = `translateX(calc(-${currentSlide * 100}% + ${percent}%))`;
  }
  
  function handleTouchEnd() {
    if (!isDragging) return;
    isDragging = false;
    
    const diff = currentX - startX;
    const threshold = carousel.offsetWidth * 0.2; // 20% of width
    
    if (Math.abs(diff) > threshold) {
      if (diff > 0) {
        // Swipe right - previous slide
        updateSlide(currentSlide - 1);
      } else {
        // Swipe left - next slide
        updateSlide(currentSlide + 1);
      }
    } else {
      // Snap back to current slide
      updateSlide(currentSlide);
    }
  }
  
  // Dot navigation
  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      updateSlide(index);
    });
  });
  
  // Auto-play
  function startAutoPlay() {
    progressBar.style.transition = 'width 5s linear';
    progressBar.classList.add('active');
    
    autoPlayInterval = setInterval(() => {
      updateSlide(currentSlide + 1);
    }, 5000);
  }
  
  function resetAutoPlay() {
    clearInterval(autoPlayInterval);
    progressBar.style.transition = 'none';
    progressBar.style.width = '0';
    progressBar.classList.remove('active');
    
    // Small delay before restarting
    setTimeout(() => {
      startAutoPlay();
    }, 100);
  }
  
  // Show swipe hint on first visit
  const hasSeenHint = localStorage.getItem('krysthal-banner-hint');
  if (!hasSeenHint) {
    const hint = document.createElement('div');
    hint.className = 'swipe-hint';
    hint.innerHTML = '← Deslize para ver mais →';
    carousel.appendChild(hint);
    
    setTimeout(() => {
      hint.remove();
      localStorage.setItem('krysthal-banner-hint', 'true');
    }, 3000);
  }
  
  // Start autoplay
  startAutoPlay();
  
  // Pause on visibility change
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      clearInterval(autoPlayInterval);
    } else {
      resetAutoPlay();
    }
  });
});